// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"09a03e2e","738":"e9fd8afe"}[chunkId] + ".chunk.js";
};